import {useEffect, useState} from 'react';

const useImageModalView = () => {
    const [open, setOpen] = useState(false);
    const [activeHover, setActiveHover] = useState(-1);
    const [currentImageIndex, setCurrentImageIndex] = useState(-1);


    const closeModalByScreenSize = () => {
        const viewportWidth = window.innerWidth;

        (viewportWidth >= 0) && (viewportWidth <= 800) && setOpen(false);
    };

    useEffect(() => {
        closeModalByScreenSize();
        window.addEventListener('resize', closeModalByScreenSize);

        return () => {
            window.removeEventListener('resize', closeModalByScreenSize);
        };
    }, []);


    return {closeModalByScreenSize,
        open,
        setOpen,
        activeHover,
        setActiveHover,
        currentImageIndex,
        setCurrentImageIndex};
};

export default useImageModalView;
